import useUser from "features/auth/useUser";
import { Merchant as MerchantApi } from "features/ecommerce/api";
import type { Merchant as MerchantType } from "features/ecommerce/types";
import { useSimpleRequest } from "hooks";
import type { ID } from "types";
import type { Merchant } from "ui/forms/ECommerce";
import { useOnboardingStepData } from "ui/organizms/ECommerce/Onboarding/common";
import { compareIds } from "util/support";

export const useDeleteIdentities = () => {
    const { data } = useOnboardingStepData<MerchantType.OnboardingIdentityVerification>();

    const request = useSimpleRequest();

    const { user } = useUser();

    const getDeleteIdentityIds = (uboIdentities: Array<Merchant.UBOIdentityVerification.Identity>) => {
        return data.uboIdentities.reduce((deleteIds, dbUboIdentity) => {
            for (const localUboIdentity of uboIdentities) {
                if (compareIds(dbUboIdentity.pki, `${localUboIdentity.pki}`)) {
                    return deleteIds;
                }
            }

            return [
                ...deleteIds,
                dbUboIdentity.pki
            ];
        }, Array.from<ID>([]));
    };

    const deleteIdentity = (uboIdentityId: MerchantType.UboIdentity['pki']) => (
        request(() => MerchantApi.deleteOnboardingsUboIdentities({
            userId: user.coreId,
            pki: uboIdentityId
        }))
    );

    const deleteIdentities = (uboIdentityIds: Array<MerchantType.UboIdentity['pki']>) => (
        Promise.allSettled(uboIdentityIds.map(deleteIdentity))
    );

    const handleDeleteIdentities = (uboIdentities: Array<Merchant.UBOIdentityVerification.Identity>) => {
        const deleteIds = getDeleteIdentityIds(uboIdentities);

        console.log('Deleting identities:', deleteIds);
        return deleteIdentities(deleteIds);
    };

    return {
        handleDeleteIdentities
    };
};

export default useDeleteIdentities;
